import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../common/DataTable';
import StatusBadge from '../common/StatusBadge';
import { formatDate } from '../../utils/formatters';
import { APPLICATION_STATUS_LABELS, statusLabel } from '../../utils/applicationStatus';
import './ApplicationList.css';

const applicantName = (app) => {
  const profile = app.applicant_profile;
  if (!profile || (!profile.first_name && !profile.last_name)) return 'Pending applicant';
  return [profile.first_name, profile.last_name].filter(Boolean).join(' ');
};

const ApplicationList = ({ applications = [], loading }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const filteredApplications = applications.filter((app) => {
    const name = applicantName(app).toLowerCase();
    const matchesSearch = !searchTerm || name.includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? app.status === statusFilter : true;
    return matchesSearch && matchesStatus;
  });

  const columns = [
    {
      header: 'Applicant',
      accessor: 'applicant_profile',
      render: (row) => (
        <div className="application-link" onClick={() => navigate(`/applications/${row.id}`)}>
          {applicantName(row)}
        </div>
      )
    },
    { header: 'Property', accessor: 'property', render: (row) => row.property?.address || '—' },
    { header: 'Status', accessor: 'status', render: (row) => <StatusBadge status={row.status} text={statusLabel(row.status)} /> },
    { header: 'Documents', accessor: 'document_count', render: (row) => row.document_count ?? 0 },
    { header: 'Created', accessor: 'created_at', render: (row) => formatDate(row.created_at) }
  ];

  return (
    <div className="application-list">
      <div className="application-list__controls">
        <input
          type="text"
          placeholder="Search by applicant name..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select className="status-filter" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="">All Statuses</option>
          {Object.entries(APPLICATION_STATUS_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>

      <DataTable
        columns={columns}
        data={filteredApplications}
        loading={loading}
        emptyMessage="No applications found matching your criteria."
      />
    </div>
  );
};

export default ApplicationList;
